import { rest } from 'msw';
import { productDetails } from './product';

export const creatProductHandlers = [
    rest.get('*/bom/:bomId/product_finder/:bodId/selected_datasheet?latest=true', (_req, res, ctx) => {
        return res(ctx.delay(2000), ctx.json(productDetails));
    })
];
